import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { TourbookSummary } from '@root/types';
import CustomIcon from '@components/shared/CustomIcon';
import truncateText from '@shared/truncateText';
import s from './TourbookCard.module.less';

type TourbookCardProps = {
  tourbook: TourbookSummary;
  onDelete: (event: React.MouseEvent) => void;
};

const TourbookCard = ({ tourbook, onDelete }: TourbookCardProps) => {
  const { t } = useTranslation('tourbook');

  return (
    <div className={s.container}>
      {tourbook.headerImage && tourbook.headerImage.smallPath ? (
        <img
          className={s.image}
          src={tourbook.headerImage.smallPath}
          alt={tourbook.headerImage.description}
        />
      ) : (
        <div className={s.emptyImageContainer}>
          <img className={s.image} src="/images/tourbook-default.jpg" alt="Tourbook Cover" />
        </div>
      )}
      <div className={s.summaryContainer}>
        <div className={s.summaryTop}>
          <h2 className={s.title}>{truncateText(tourbook.name, 40)}</h2>
          <p className={s.description}>{truncateText(tourbook.description, 50)}</p>
        </div>
        <div className={s.summaryBottom}>
          <p className={s.lastUpdated}>{t('updated_ago', { time: tourbook.lastUpdatedString })}</p>
          <div className={s.iconsContainer}>
            <div>
              <CustomIcon type="buildings-multiple" className={s.attributeIcon} />
              <span className={s.attributeText}>{tourbook.listingCount}</span>
            </div>
            <Tooltip
              overlayClassName={s.tooltip}
              trigger="hover"
              placement="bottom"
              arrowPointAtCenter
              title={t('listingCard.viewCountTooltip')}
            >
              <div>
                <CustomIcon type="eye" className={s.attributeIcon} />
                <span className={s.attributeText}>{tourbook.views}</span>
              </div>
            </Tooltip>
            <div
              className={s.deleteButton}
              onClick={event => onDelete(event)}
              role="button"
              data-testid="deleteButton"
            >
              <CustomIcon type="trash" className={s.trashIcon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourbookCard;
